
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import SystemModule from "@/store/modules/system";

const systemModule = getModule(SystemModule);

@Component
export default class SaveIndicatorDialog extends Vue {
  get saving() {
    return systemModule.saving;
  }
}
